import noop from 'lodash/noop';
import { createContext } from 'react';

import type { useRequestsLoaderState } from './hooks';

export type Context = ReturnType<typeof useRequestsLoaderState>;

export const context = createContext<Context>([
  {
    isUserLoading: true,
    isSchoolSettingsLoading: true,
    isTranslationLoading: true,
    isUserSettingsLoading: true,
  },
  noop,
]);

export const { Provider } = context;
